<template>
    <v-layout justify-center>
        <v-responsive max-width="1440px" width="100%" height="100%">
            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">실측기술자 목록</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text class="py-0">
                        <v-row align="center">
                            <v-col cols="12" md="3" class="py-0">
                                <v-select v-model="filter.searchKey" label="검색조건" placeholder=" " :items="searchKeyItems" dense hide-details></v-select>
                            </v-col>
                            <v-col cols="12" md="3" class="py-0">
                                <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " dense hide-details :disabled="!filter.searchKey"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="pt-0">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="search"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <v-data-table :headers="headers" :items="users" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
                <template v-slot:item.meta.interior="{ item }">
                    <div v-if="item.meta.interiorApplication">
                        <span
                            >카테고리:
                            <span v-for="(category, index) in item.meta.interiorCategories" :key="category"><span v-if="index">, </span>{{ category }}</span>
                        </span>
                    </div>
                </template>
                <template v-slot:item.measurerEnabled="{ item }">
                    <v-row justify="center" align="center">
                        <v-col cols="auto" class="pa-0">
                            <v-switch v-model="item.scope" value="measurer" color="green" hide-details dens class="mt-0" @change="save({ _id: item._id, scope: item.scope })"></v-switch>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:item.createDate="{ item }">
                    {{ (item.createDate || "").toDateTime() }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small @click="edit(item)"> mdi-pencil </v-icon>
                </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" class="mt-4 mb-12" @input="search"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

export default {
    data() {
        return {
            showSearch: true,

            users: [],

            filter: {
                _level: null,
                searchKey: null,
                searchValue: null,
            },

            searchKeyItems: [
                { text: ":: 전체 ::", value: null },
                { text: "사용자 이름", value: "name" },
                { text: "연락처", value: "phone" },
            ],

            page: 1,
            pageCount: 0,
            limit: 10,

            headers: [
                {
                    text: "사용자 이름",
                    align: "center",
                    width: 128,
                    value: "name",
                },
                {
                    text: "이메일",
                    align: "center",
                    width: 200,
                    value: "email",
                },
                {
                    text: "연락처",
                    align: "center",
                    width: 140,
                    value: "phone",
                },
                {
                    text: "실측기술자 승인",
                    align: "center",
                    width: 120,
                    value: "measurerEnabled",
                },
                {
                    text: "가입일자",
                    align: "center",
                    width: 200,
                    value: "createDate",
                },
                {
                    text: "Actions",
                    align: "center",
                    width: 100,
                    value: "actions",
                },
            ],
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            try {
                // var { levels } = await api.console.levels.getLevels({
                //     params: { code: "technician" },
                // });
                // var [level] = levels || [];
                // this.filter._level = level._id;
                this.search(false);
            } catch (error) {
                handleError(error);
            }
        },

        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, this.query, {
                            page: this.page,
                        }),
                    });
                }

                var { summary, users } = await api.console.users.getUsers({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.users = users;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                handleError(error);
            }
        },

        async save(user) {
            try {
                await api.console.users.putUser(user);
                this.search(false);
            } catch (error) {
                handleError(error);
            }
        },

        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },

        edit(user) {
            this.$router.push({
                path: `${this.$route.path}/${user._id}`,
            });
        },
    },
};
</script>

<style lang="css" scoped></style>
